import { Bell, BellOff } from "lucide-react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { usePushNotifications } from "@/hooks/usePushNotifications";
import { toast } from "sonner";

interface Props {
  variant?: "menu" | "button";
}

export const NotificationToggle = ({ variant = "menu" }: Props) => {
  const { isSupported, permission, isSubscribed, loading, subscribe, unsubscribe } =
    usePushNotifications();

  if (!isSupported) return null;

  const toggle = async () => {
    if (isSubscribed) {
      await unsubscribe();
      toast.success("Bildirimler kapatıldı");
    } else {
      const ok = await subscribe();
      if (ok) toast.success("Bildirimler açıldı");
      else if (permission === "denied")
        toast.error("Tarayıcı izni reddedilmiş. Tarayıcı ayarlarından açabilirsin.");
    }
  };

  const Icon = isSubscribed ? BellOff : Bell;
  const label = loading
    ? "İşleniyor..."
    : isSubscribed
      ? "Bildirimleri Kapat"
      : "Bildirimleri Aç";

  if (variant === "button") {
    return (
      <Button
        variant="ghost"
        onClick={toggle}
        disabled={loading}
        className="w-full justify-start"
      >
        <Icon className="mr-2 h-4 w-4" />
        {label}
      </Button>
    );
  }

  return (
    <DropdownMenuItem
      className="cursor-pointer"
      onSelect={(e) => {
        e.preventDefault();
        void toggle();
      }}
      disabled={loading}
    >
      <Icon className="mr-2 h-4 w-4" />
      <span>{label}</span>
    </DropdownMenuItem>
  );
};
